import { format, isValid, parseISO } from "date-fns";

export function toPdfDisplayValue(value: string | null | undefined): string {
  const trimmed = value?.trim();
  if (!trimmed || trimmed === "N/A") return "";
  return trimmed;
}

export function formatRetailCtmPdfDateTime(date: Date = new Date()): string {
  return format(date, "yyyyMMdd_HH_mm");
}

export function formatRetailCtmPdfDate(
  value: Date | string | null | undefined,
): string {
  if (!value) return "";

  const date = value instanceof Date ? value : parseISO(String(value));
  if (!isValid(date)) {
    return toPdfDisplayValue(String(value));
  }

  return format(date, "dd/MM/yyyy");
}

export function formatRetailCtmPdfYesNo(
  value: boolean | null | undefined,
): string {
  if (value === null || value === undefined) return "";
  return value ? "Oui" : "Non";
}

export function formatRetailCtmPdfTradeIn(
  hasTradeIn: boolean,
  count: number,
): string {
  if (!hasTradeIn) return "Non";
  return count > 0 ? `Oui - ${count}` : "Oui";
}

export function buildRetailCtmSummaryPdfFilename(
  commissionNumber?: string | null,
  commissionYear?: string | null,
  generatedAt: Date = new Date(),
): string {
  const numberPart = commissionNumber?.trim() ?? "";
  const yearPart = commissionYear?.trim() ?? "";
  const datePart = formatRetailCtmPdfDateTime(generatedAt);
  return `recapitulatif_ctm_${numberPart}_${yearPart}_${datePart}.pdf`;
}
